import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardGridPanelComponent } from './card-grid-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [CardGridPanelComponent],
  exports: [CardGridPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class CardGridPanelModule { }
